import React from "react";
import { Box, Typography, Paper, CircularProgress } from "@mui/material";
import Card from "../Card/Card";
import useFetch from "../../hooks/useFetch";
import { FormattedMessage } from "react-intl";
import FeaturedDesc from "./FeaturedDesc";
import { useSelector } from "react-redux";
import { getTheme } from "../../theme"
// minWidth 0 lets the grid track shrink below a long, non-wrapping product title.
const FeaturedProductItem = ({ item, currency, rates }) => (
  <Box sx={{ width: "100%", height: "100%", minWidth: 0 }}>
    <Card
      item={item}
      currency={currency}
      rates={rates}
      eager
    />
  </Box>
);

const MemoizedFeaturedProductItem = React.memo(FeaturedProductItem);

const FeaturedProducts = ({ products,
  type,
  title,
  isNew,
  descriptionNew,
  descriptionFeatured
}) => {
  const locale = useSelector((state) => state.language?.locale || "pl");
  const { data, loading, error } = useFetch(
    `/products?populate=*&[filters][type][$eq]=${type}&[filters][locale][$eq]=${locale}`
  );
  const selectedCurrency = useSelector((state) => state.currency.selectedCurrency);
  const rates = useSelector((state) => state.currency.rates);
  const theme = getTheme();

  return (
    <Box
      sx={{
        mt: { xs: 8, sm: 14 },
        px: { xs: 2, sm: 4, md: 6 },
        py: { xs: 2, sm: 4 },
        width: "100%",
        boxSizing: "border-box",
        // minHeight: "100vh"
      }}
    >
      {/* Header */}
      <div className="section-heading">
        <span className="eyebrow">Carlo Bossi</span>
        <h2 className="title">{title || type}</h2>
        <span className="rule" />
        <div className="lead">
          <FeaturedDesc
            isNew={isNew}
            descriptionNew={descriptionNew}
            descriptionFeatured={descriptionFeatured}
          />
        </div>
      </div>
      {/* Product Grid */}
      {
        error ? (
          <Paper elevation={0} sx={{ p: 2, color: "text.secondary", textAlign: "center", mt: 4 }}>
            <FormattedMessage id="generic_error" />
          </Paper>
        ) : loading ? (
          <Box sx={{ display: "flex", justifyContent: "center", py: 8 }}>
            <CircularProgress />
          </Box>
        ) : (
          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: { xs: "repeat(2, minmax(0, 1fr))", sm: "repeat(3, minmax(0, 1fr))", md: "repeat(4, minmax(0, 1fr))" },
              columnGap: { xs: "12px", sm: "24px", md: "32px" },
              rowGap: { xs: "32px", md: "56px" },
              maxWidth: 1600,
              mx: "auto",

            }}
          >
            {(Array.isArray(data) ? data : []).map(item => (
              <MemoizedFeaturedProductItem
                key={item.id}
                item={item}
                currency={selectedCurrency}
                rates={rates}
              />
            ))}
          </Box>
        )
      }
    </Box >
  );
};

export default FeaturedProducts;
